import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategorySection() {
  return (
    <section className="bg-background-100 border-y border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            内容分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            探索你感兴趣的日韩娱乐内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => {
            const colorClass = cat.color === 'accent'
              ? 'bg-accent-50 text-accent-700 hover:bg-accent-100 group-hover:border-accent-300'
              : cat.color === 'secondary'
              ? 'bg-secondary-50 text-secondary-700 hover:bg-secondary-100 group-hover:border-secondary-300'
              : 'bg-primary-50 text-primary-700 hover:bg-primary-100 group-hover:border-primary-300';

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group block p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-md mb-3 transition-colors duration-200 ${colorClass}`}>
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}